import React from 'react';
const PORTRAIT = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesign/New/Jose%20Medina.jpg?opt=w3';
export function PortraitIntroSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-543">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-544">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-545">
          {/* Portrait */}
          <div className="lg:col-span-4 flex justify-center" data-id="element-546">
            <div className="relative p-2 border border-brand-gray-700 bg-brand-gray-900 max-w-[350px]" data-id="element-547">
              <img src={PORTRAIT} alt="Jose Medina" className="block w-full h-auto object-cover" data-id="element-548" />
              <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand-teal z-10" data-id="element-549" />
              <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand-teal z-10" data-id="element-550" />
              <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand-teal z-10" data-id="element-551" />
              <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand-teal z-10" data-id="element-552" />
            </div>
          </div>

          {/* Intro Text */}
          <div className="lg:col-span-8" data-id="element-553">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-white uppercase tracking-wide mb-6" data-id="element-554">
              Elevating Tactical Training & Security Consulting
            </h2>
            <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed" data-id="element-555">
              <p data-id="element-556">
                At{' '}
                <strong className="text-brand-white" data-id="element-557">
                  Medina Tactical Dynamics (Awareness Protective Consultants,
                  LLC)
                </strong>
                , we are dedicated to delivering world-class tactical training,
                security consulting, and threat assessment solutions to law
                enforcement, military personnel, corporate clients, and
                individuals. Founded by{' '}
                <strong className="text-brand-white" data-id="element-558">Jose Medina</strong>, our
                firm has established a global reputation for excellence in
                advanced training and strategic security services.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}